class Interfaces {
    constructor( core ) {
        this.core = core
    }

    //{ AppCore.Interfaces.t( "" ) }
    ///*CORES*/
    //import AppCore from 'cores/AppCore'
    /*i = {
        {
        "DoctorLanding.Ui.Review.Index.ShowAllText" :"Читать далее",
        "DoctorLanding.Ui.AnswerCard.Index.ShowAllText" :"Читать далее",
        "DoctorLanding.Ui.ContInstagram.InstagramSlider.ButtonShowAll" :"Показать ещё"
        }

        //{ AppCore.Interfaces.t( "" ) }

    }*/

    t(path) {
        const { interfaces } = this.core.store.getState().settings

        return interfaces[path]
    }

    of(partOfPath) {
        if (partOfPath[partOfPath.length - 1] === ".") {
            partOfPath = partOfPath.substr(0, partOfPath.length - 1)
        }

        return (path) => this.t(`${partOfPath}.${path}`)
    }

    /*t( path ) {
        const { lang = 'ru' } = this.core.store.getState().settings

        const { interfaces = {} } = this

        let value = interfaces[ lang ][ path ]

        if( !value && lang != 'ru' )
        {
            value = interfaces[ 'ru' ][ path ]
        }

        return value
    }*/
}

export default Interfaces